<template>
  <div class="ch-widget ch-newslinks mb-6 mx-auto" style="max-width:300px;">
    <v-subheader class="text-overline primary--text">Today's Newslinks</v-subheader>
    <v-card color="primary" dark class="mb-6 pa-1 mx-auto" max-width="300" min-height="240" flat :href="item.link" v-if="item">
      <v-card-title class="overlinex text--uppercasex">
        <span v-html="newslinkTitle(item.title)"></span>
        <!-- <v-icon right dark>mdi-arrow-right</v-icon> -->
      </v-card-title>
      <v-card-text v-html="newslinkList(item.excerpt)"></v-card-text>
      <!-- <v-card-text class="pt-0">...</v-card-text> -->
<!--       <v-card-actions>
        <v-btn color="accent" dark :href="item.link" block depressed>
          Today's Newslinks
        </v-btn>
      </v-card-actions> -->
<!--       <v-card-actions>
        <v-btn :href="item.link" text block dark>Continue Reading <v-icon right>mdi-arrow-right</v-icon></v-btn>
      </v-card-actions> -->
    </v-card>
  </div>
</template>

<script>
  // import _ from 'lodash'

  export default {
    name: 'NewslinksWidget',

    props: {
      title: {
        type: String,
        default: 'Today\'s Newslinks'
      },
      // text: {
      //   type: String,
      //   default: 'Each weekday – between 9am and 10am – we send The Conservative Daily with links to all the big Tory news stories.'
      // },
      link: {
        type: String,
        default: '/newslinks'
      }
    },

    data: () => ({
      item: null,
      items: []
    }),

    methods: {
      getLatestNewslink() {
        this.$axios.get('/wp-json/wp/v2/posts?categories=67,98&filter[orderby]=date&order=desc&per_page=1')
          .then(response => { // 160,43,
            this.item = response.data[0]
            this.items = response.data
          })
      },
      newslinkList(excerpt) {
        return excerpt.replace(/(\s\|\s)/g, '...<br><br>') + '...'
        // return _.replace(excerpt, regex, '<br><br>')
      },
      newslinkTitle(title) {
        return title.replace('Newslinks for ', '')
      }
    },

    mounted() {
      this.getLatestNewslink()
    }

  }
</script>

<style lang="sass" scoped>
  .v-card__title
    word-break: initial
    font-size: 1rem
    line-height: 1.15rem
</style>